import { BookOpen, Pulse, RocketLaunch, type Icon } from '@phosphor-icons/react'

import { navigateOnPlainClick } from '../../shell/links.ts'
import { BarcodeStamp } from './Barcode.tsx'

// "Where to start": the three paths off the landing page. Each card is a real
// anchor (see links.ts) with the design's hover lift carried by `.landing-card`.
const CARDS: {
  icon: Icon
  title: string
  body: string
  cta: string
  path: string
  enterDelay: string
}[] = [
  {
    icon: RocketLaunch,
    title: 'Start a new integration',
    body: 'Go from your first sandbox quote to a booked delivery — step-by-step guides for the common integration paths.',
    cta: 'Read the guides',
    path: '/docs/graphql/getting-started',
    enterDelay: '0.16s',
  },
  {
    icon: BookOpen,
    title: 'Explore the API',
    body: 'Quote, book, and track deliveries with the GraphQL API. Browse every query and mutation, with examples to run against sandbox.',
    cta: 'Open the API docs',
    path: '/docs/graphql',
    enterDelay: '0.22s',
  },
  {
    icon: Pulse,
    title: 'Monitor your integration',
    body: 'Webhook deliveries, API bookings, and keys in one place. See what Curri sent, how your endpoint responded, and resend anything that failed.',
    cta: 'Open the dashboard',
    path: '/dashboard/webhooks',
    enterDelay: '0.28s',
  },
]

export const StartCards = ({
  onNavigate,
}: {
  onNavigate: (path: string) => void
}) => (
  <>
    <div
      style={{ display: 'flex', alignItems: 'center', gap: 14, marginTop: 76 }}
    >
      <h2 style={{ fontSize: 25 }}>Where to start</h2>
      <span style={{ flex: 1 }} />
      <BarcodeStamp tone="muted" />
    </div>

    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: 16,
        marginTop: 18,
      }}
    >
      {CARDS.map(card => (
        <a
          key={card.title}
          href={card.path}
          onClick={navigateOnPlainClick(onNavigate, card.path)}
          className="landing-up landing-card"
          style={{
            display: 'flex',
            flexDirection: 'column',
            background: 'var(--curri-surface)',
            border: '1px solid var(--curri-border)',
            borderRadius: 'var(--curri-radius-lg)',
            padding: 22,
            color: 'var(--curri-text)',
            animationDelay: card.enterDelay,
          }}
        >
          <card.icon size={21} style={{ color: 'var(--curri-accent)' }} />
          <div
            style={{
              marginTop: 14,
              fontSize: 16,
              fontWeight: 600,
              letterSpacing: '-0.01em',
            }}
          >
            {card.title}
          </div>
          <p
            style={{
              margin: '6px 0 0',
              flex: 1,
              fontSize: 14,
              lineHeight: 1.55,
              color: 'var(--curri-text-secondary)',
              textWrap: 'pretty',
            }}
          >
            {card.body}
          </p>
          <div
            style={{
              marginTop: 16,
              fontSize: 14,
              fontWeight: 600,
              color: 'var(--curri-accent)',
            }}
          >
            {card.cta} <span aria-hidden="true">→</span>
          </div>
        </a>
      ))}
    </div>
  </>
)
